<div class="flex flex-col w-full gap-4">
  <div class="px-1 w-full 2xl:w-[95%] mx-auto flex justify-between items-center">
    <div class="px-1 sm:px-2 flex flex-col gap-1 py:4">
      <div class="text-(--color-text-primary) font-semibold text-2xl">
        {{ 'requests.myReports.title' | translate }}
      </div>
      <div class="text-(--color-text-primary) text-lg font-light">
        {{ 'requests.myReports.subtitle' | translate }}
      </div>
    </div>
    <div class="flex gap-2">
      <button
        matMiniFab
        class="text-lg bg-transparent! shadow-none! rounded-full! border! border-(--comp-icon-color-secondary)!"
        (click)="changeTable(true)"
      >
        <mat-icon
          class="text-2xl! size-6! text-(--comp-icon-color-secondary)! material-symbols-outlined"
          >border_all</mat-icon
        >
      </button>
      <button
        matMiniFab
        class="text-lg bg-transparent! shadow-none! rounded-full! border! border-(--comp-icon-color-secondary)!"
        (click)="changeTable(false)"
      >
        <mat-icon
          class="text-2xl! size-6! text-(--comp-icon-color-secondary)! material-symbols-outlined"
          >list</mat-icon
        >
      </button>
    </div>
  </div>

  <div class="px-1 w-full 2xl:w-[95%] mx-auto">
    <div class="general-box">
      <div class="text-(--color-text-primary) font-semibold text-2xl">
        {{ 'requests.myReports.openFolios' | translate }}
      </div>

      @if (isTable) {
        <div
          class="grid gap-2 gap-y-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-4"
        >
          @for (card of workFlowProjectCards; track card) {
            <app-card-request
              class="w-full max-w-100! m-auto"
              [ticketSection]="card"
              (detailEvent)="openDetailRequest(card.id)"
            >
            </app-card-request>
          }
        </div>
        <!-- Tabla General Simple para Abiertos -->
      } @else {
        <app-table-general
          [headers]="headers"
          [dataSource]="dataSource"
          [isLoading]="isLoading"
          [buttonEvent]="true"
          (idEmitter)="openDetailRequest($event)"
        ></app-table-general>
      }
      <mat-paginator
        [length]="dataLength"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex - 1"
        (page)="onPageChange($event)"
        [pageSizeOptions]="[8, 16, 52]"
        [attr.aria-label]="'common.accessibility.selectPage' | translate"
      >
      </mat-paginator>
    </div>
  </div>
</div>
